import { render, staticRenderFns } from "./NewTier.vue?vue&type=template&id=6cf61381&"
import script from "./NewTier.vue?vue&type=script&lang=js&"
export * from "./NewTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports